import { useState } from "react";
import ReactTooltip from "react-tooltip";
import { ModalDelete } from "expano-components";
import useCreate from "hooks/useCreate";
import useDelete from "hooks/useDelete";
import AssignUserModal from "./components/AssignUserModal";

const Avatar = ({
  id,
  user,
  product_group_name,
  product_group_id,
  refetch,
  type,
  workers,
}) => {
  const [show_delete_modal, setOpenDeleteModal] = useState(false);
  const [show_assign_modal, setOpenAssignModal] = useState(false);

  const { is_creating: is_assigning, create: assignUserToProductGroup } =
    useCreate({
      path: "/product_group_assigns",
      success_message: "Przypisano pomyślnie",
      onSuccess: () => {
        setOpenAssignModal(false);
        refetch();
      },
    });

  const { _delete: deleteProductGroupAssign } = useDelete({
    path: `/product_group_assigns/${id}`,
    onSuccess: () => {
      setOpenDeleteModal(false);
      refetch();
    },
  });

  if (type === "edit") {
    return (
      <div
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <button
          className="avatar"
          type="button"
          data-tip={user?.full_name}
          onClick={() => setOpenDeleteModal(true)}
        >
          <ReactTooltip
            arrowColor="transparent"
            backgroundColor="#fff"
            textColor="#000"
            place="right"
            type="light"
            effect="solid"
          />
          <span>{user.initials}</span>
          <span className="remove-overlay">
            <svg width="14px" height="14px" viewBox="0 0 24 24" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                fill="#fff"
              />
            </svg>
          </span>
        </button>
        {show_delete_modal && (
          <ModalDelete
            handleDelete={deleteProductGroupAssign}
            handleClose={() => setOpenDeleteModal(false)}
            name={`przypisanie pracownika ${user?.full_name} z producktu grupowego ${product_group_name}?`}
          />
        )}
      </div>
    );
  }
  if (type === "add") {
    return (
      <div
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <button
          className="avatar add"
          type="button"
          onClick={() => setOpenAssignModal(true)}
        >
          <svg
            width="14px"
            height="14px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 12H20M12 4V20"
              stroke="#fff"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        {show_assign_modal && (
          <AssignUserModal
            workers={workers}
            is_loading={is_assigning}
            product_group_name={product_group_name}
            handleClose={() => setOpenAssignModal(false)}
            handleAssign={(user_id) =>
              assignUserToProductGroup({ user_id, product_group_id })
            }
          />
        )}
      </div>
    );
  }
  return null;
};

export default Avatar;
